import { _ as _sfc_main } from "./VaFileUploadListItem.vue_vue_type_script_lang-205f1dee.mjs";
import { resolveComponent, openBlock, createBlock, normalizeClass, withCtx, createVNode, createElementVNode, createElementBlock, toDisplayString, createCommentVNode, withModifiers, withKeys } from "vue";
import { _ as _export_sfc } from "../../../../plugin-vue_export-helper-cc2b3d55.mjs";
const VaFileUploadListItem_vue_vue_type_style_index_0_lang = "";
const _hoisted_1 = { class: "va-file-upload-list-item__content" };
const _hoisted_2 = {
  key: 0,
  class: "va-file-upload-list-item__name"
};
const _hoisted_3 = { class: "va-file-upload-list-item__size" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_va_file_upload_undo = resolveComponent("va-file-upload-undo");
  const _component_va_list_item_section = resolveComponent("va-list-item-section");
  const _component_va_button = resolveComponent("va-button");
  const _component_va_list_item = resolveComponent("va-list-item");
  return openBlock(), createBlock(_component_va_list_item, {
    class: normalizeClass(["va-file-upload-list-item", _ctx.computedClasses]),
    tabindex: "-1",
    disabled: _ctx.disabled,
    "aria-disabled": _ctx.disabled
  }, {
    default: withCtx(() => [
      _ctx.removed && _ctx.undo ? (openBlock(), createBlock(_component_va_list_item_section, { key: 0 }, {
        default: withCtx(() => [
          createVNode(_component_va_file_upload_undo, { onRecover: _ctx.recoverFile }, null, 8, ["onRecover"])
        ]),
        _: 1
      })) : (openBlock(), createBlock(_component_va_list_item_section, { key: 1 }, {
        default: withCtx(() => [
          createElementVNode("div", _hoisted_1, [
            _ctx.file && _ctx.file.name ? (openBlock(), createElementBlock("div", _hoisted_2, toDisplayString(_ctx.file && _ctx.file.name), 1)) : createCommentVNode("", true),
            createElementVNode("div", _hoisted_3, toDisplayString(_ctx.file && _ctx.file.size), 1),
            !_ctx.disabled ? (openBlock(), createBlock(_component_va_button, {
              key: 1,
              flat: "",
              color: "danger",
              icon: "clear",
              class: "va-file-upload-list-item__delete",
              "aria-label": _ctx.tp(_ctx.$props.ariaRemoveFileLabel),
              onClick: withModifiers(_ctx.removeFile, ["stop"]),
              onKeydown: [
                withKeys(withModifiers(_ctx.removeFile, ["stop"]), ["enter"]),
                withKeys(withModifiers(_ctx.removeFile, ["stop"]), ["space"])
              ],
              onFocus: _ctx.onFocus,
              onBlur: _ctx.onBlur
            }, null, 8, ["aria-label", "onClick", "onKeydown", "onFocus", "onBlur"])) : createCommentVNode("", true)
          ])
        ]),
        _: 1
      }))
    ]),
    _: 1
  }, 8, ["class", "disabled", "aria-disabled"]);
}
const _VaFileUploadListItem = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  _VaFileUploadListItem as _
};
//# sourceMappingURL=VaFileUploadListItem-060673d5.mjs.map
